import { z } from 'zod';

import {
  PermissionResourceT,
  ZodPermissionActionTWithWildcard,
} from '@Common/types/bo/authorization';

export const ZodB2BResources = z.enum([
  'auth/identity',
  'auth/activation',
  'backend_version',
  'companies',
  'companies/plans',
  'companies/plans/matching_contribution_config',
  'companies/documents',
  'presigned_url',
  'dashboard',
  'companies/dashboard/active_campaigns',
  'companies/dashboard/savings',
  'companies/dashboard/matching_contributions',
  'companies/dashboard/affiliates',
  'companies/payment_methods',
  'companies/payment_methods/bank_details',
  'companies/payment_methods/draft_unsigned_mandate',
  'employees',
  'employees/bulk_activated_invitation',
  'employees/bulk_create',
  'employees/bulk_create_validate',
  'employees/bulk_upload/results',
  'employees/bulk_upload/errors',
  'employees/documents',
  'employees/locked_funds',
  'employees/matching_contributions',
  'employees/portfolio',
  'employees/send_activated_invitation',
  'beneficiaries',
  'orders',
  'withdrawals',
  'withdrawals/amounts',
  'withdrawals/eligible_allocations',
  'withdrawals/cancel',
  'withdrawals/bulk',
  'withdrawals/bulk/template',
  'withdrawals/bulk/positions',
  'withdrawals/bulk/payout_information',
  'savings_funds_requests',
  'savings_funds_requests/employees',
  'contracts',
  'contracts/documents',
  'recurring_fee_charges',
  'campaigns',
  'campaigns/migrated',
  'collective_operations',
  'orders/fully_managed_plan_contributions',
  'campaigns/payouts',
  'campaigns/employees_awaiting_response',
  'campaigns/allocations',
  'campaigns/dashboard/answer_rate',
  'campaigns/dashboard/amounts',
  'campaigns/calculate_matching_contributions',
  'campaigns/detailed_reporting',
  'operations_er',
  'individual_operations',
  'individual_operations/orders',
  'recurring_investments',
  'recurring_investments/allocations',
  'recurring_investments/executions',
  'contract_fee_charges',
  'distributor',
  'distributor/dashboard/outstanding_timeline',
  'distributor/dashboard/outstanding_breakdown',
  'distributor/dashboard/outstanding_timeline/er',
  'distributor/dashboard/outstanding_breakdown/er',
  'distributor/dashboard/companies_employees_distribution',
  'admins',
  'admins/invite',
  'admins/login_link',
  'admins/restricted_modification',
  'admins/tutorial_done',
  'indexes',
  'instruments',
  'instruments/documents',
  'instruments/cutoff_dates',
  'contact_request',
  'services',
  'investor_profile',
  'status/ping',
]);
export const ZodB2BResourcesWithWildcard = z.enum([...ZodB2BResources.options, '*']);

export type B2BResources = z.TypeOf<typeof ZodB2BResources>;

const ZodWMResources = z.enum(['companies', '*']);

export type WMResources = z.TypeOf<typeof ZodWMResources>;

const ZodBoExternalPermissionActionT = z.union([
  ZodPermissionActionTWithWildcard,
  z.array(ZodPermissionActionTWithWildcard),
]);
export type BoExternalPermissionActionT = z.TypeOf<typeof ZodBoExternalPermissionActionT>;

export const ZodBOExternalPermissionT = z.object({
  action: ZodBoExternalPermissionActionT,
  resource: ZodB2BResourcesWithWildcard,
});

export type B2BPermissionT = z.TypeOf<typeof ZodBOExternalPermissionT>;

export type BOResourceAll = PermissionResourceT | B2BResources | WMResources;
